import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { assignCoverPhotos } from '../../../../commons/utils/assignCoverPhotos';
import { getWhatshotPublishersAPI } from './api';
import fallbackData from './data/whatshot-publishers.json';

async function getWhatshotPublishers() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    const res = await getWhatshotPublishersAPI({ token: session?.token, traceId });

    console.log('getWhatshotPublishers() RESONSE -> ', res);
    const publishers = res?.data?.data?.publishers || res?.data?.publishers || null;
    console.log('getWhatshotPublishers() publishers -> ', publishers);

    if (publishers) {
        // TODO: Simplify — assign color directly when coverPhoto is missing, instead of chaining two passes.
        // Logic should be: if !coverPhoto → assign a coverColor; if coverPhoto → use the image.
        this.whatshotPublishers = assignCoverPhotos(assignPublisherColors(publishers));
    } else {
        // NOTE: fallback to static JSON until API is available in all environments
        this.whatshotPublishers = assignCoverPhotos(fallbackData.publishers);
    }

    this.featuredPublishers = this.whatshotPublishers.slice(0, 6);
    // TODO: replace with real API data when available
    this.popularNowPublishers = this.whatshotPublishers.slice(0, 3);
    this.nearMePublishers = this.whatshotPublishers.slice(0, 4);
    this.observed.featuredPublishers = uuidv4();
    this.observed.whatshotPublishers = uuidv4();
    this.observed.popularNowPublishers = uuidv4();
    this.observed.nearMePublishers = uuidv4();
}

export default getWhatshotPublishers;
